<template>
   <div class="menu_left cflex" :style="{width:sidebar.width+'px'}">
        <div class="menu_page_top rflex">
            <img :class='["logo",{"closeLogo":!sidebar.opened}]' src="../../assets/logo_small.png" alt="vknow" >
            <span class='title' v-show="sidebar.opened">V<i>Know</i></span>
        </div>
        <div class="menu_page_bottom is-scroll-left">
            <el-menu
                mode="vertical"
                theme="dark"
                :show-timeout="200"
                :default-active="$route.path"
                :collapse="isCollapse"
                :background-color="menuObj.bgColor"
                :text-color="menuObj.textColor"
                :active-text-color="menuObj.activeTextColor"
                :style="{width:sidebar.width+'px'}"
                >
                    <template v-for="(item,index) in userData">
                        <!--表示 有一级菜单-->
                        <div v-if="!item.children || item.children.length == 0">
                            <router-link v-if="!item.url || item.url == ''" :to="item.path" :key="index">
                                <el-menu-item class="dropItem" :index="item.path">
                                    <i v-if="item.icon" :class="item.icon"></i>
                                    <span v-if="item.name" slot="title">{{ item.name}}</span>
                                </el-menu-item>
                            </router-link>
                            <a v-else target="_blank" :href="item.url">
                                <el-menu-item class="dropItem" :index="item.path">
                                    <i v-if="item.icon" :class="item.icon"></i>
                                    <span v-if="item.name" slot="title">{{ item.name}}</span>
                                </el-menu-item>
                            </a>
                        </div>


                        <!--表示 有二级或者多级菜单 -->
                        <el-submenu v-if="item.children && item.children.length >= 0" :index="'item-'+index" :key="index" class="dropItem">
                            <template slot="title">
                                <i v-if="item.icon" :class="item.icon"></i>
                                <span v-if="item.name" slot="title">{{item.name}}</span>
                            </template>
                            <!--直接定位到子路由上，子路由也可以实现导航功能-->
                            <div v-for="(citem,cindex) in item.children">

                                <router-link :target="citem.target?'_blank':'_self'" v-if="!citem.url || citem.url == ''" :to="citem.path"  :key="cindex">
                                    <el-menu-item :index="citem.path">
                                        <span slot="title"> {{citem.name}}</span>
                                    </el-menu-item>
                                </router-link>
                                <a v-else target="_blank" :href="citem.url">
                                    <el-menu-item :index="citem.path">
                                        <span slot="title"> {{citem.name}}</span>
                                    </el-menu-item>
                                </a>
                            </div>
                        </el-submenu>
                    </template>
            </el-menu>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import XEUtils from "xe-utils";
    import * as simpleApi from "request/simple";


export default {
  name: "left-Menu",
  data() {
    return {
        isInCefClient: false,
       menuObj:{
        //  侧边栏菜单背景
        //  bgColor:'#edafff',
         textColor:'#666',
        //  侧边栏菜单选中
         activeTextColor:'#0e70fb',
       },
      allExtMenu: [],
        data: [{
            name: "主页", path: "/",menuId:"07bbb5ccc3c6401bba3dfdf2095a1932", icon:  "vknowfont vicon-shouye", allows: ['admin', 'sclAdmin', 'teacher', 'student'],
        }, {
            name: "基础信息管理",menuId:"27fb0ba0a5a74d5a87171148f2db1827", icon:  "vknowfont vicon-svg-",  allows: ['admin'],
            children: [
                {
                    name: "二级单位信息",menuId:"29d9312903d1498389364df7fdbe46cf", icon:  "el-icon-user", path: "/mainPage/schoolList", allows: ['admin'],
                }, {
                    name: "二级单位管理员",menuId:"3002639c97c84efb8c1d3081805c1625", icon:  "el-icon-user", path: "/mainPage/admin2List", allows: ['admin'],
                }, {
                    name: "专业管理",menuId:"4e9eeb4bcdde4c9299a99e941e454bc2", icon:  "el-icon-microphone", path: "/mainPage/professionList", allows: ['admin'],
                }
            ]
        }, {
            name: "用户管理",menuId:"5375542326e34411abdf073703b07706", icon:  "vknowfont vicon-yonghu", path: "/mainPage/schoolList", allows: ['admin'],
            children: [{
                name: "学生信息",menuId:"53f61a5949da4826ba51cdc7d828340b", icon:  "el-icon-help", path: "/mainPage/studentList", allows: ['admin'],
            }, {
                name: "教师信息",menuId:"6486c69be54b4e1491223faf9f734e59", icon:  "el-icon-s-order", path: "/mainPage/teacherList", allows: ['admin'],
            }, {
                name: "行政班信息",menuId:"78b526e0bb33415f92803273f175baf5", icon:  "el-icon-upload", path: "/mainPage/hardClassList", allows: ['admin'],
            }, {
                name: "课程信息",menuId:"835410193741498983385fadf339cbbc", icon:  "el-icon-s-tools", path: "/mainPage/courceList", allows: ['admin'],
            }, {
                name: "教学班信息",menuId:"90b3f5074e0440ada5e6f5081cfb32cf", icon:  "el-icon-help", path: "/mainPage/teachingClassList", allows: ['admin'],
            }, {
                name: "综合上传",menuId:"a548cb4908b24757b67a526c638ee5ee", icon:  "el-icon-upload2", path: "/mainPage/allUpload", allows: ['admin'],
            }]
        }, {
            name: "作弊学生列表",menuId:"af44fe15f3f74cd2bc5967483a75a2c6", icon:  "vknowfont vicon-ceshi", path: "/mainPage/zbStudentList", allows: ['admin'],
        }, {
            name: "试卷归档",menuId:"baaebc10696e486ca7d375d2e4878f77", icon:  "vknowfont vicon-guidang", path: "/mainPage/archiveExamList", allows: ['admin'],
        }, {
          name: "班级统计",menuId:"ca7e777edb5d4675a0fbf5b73ebaa424", icon:  "vknowfont vicon-guidang", path: "/mainPage/hardAnalyList", allows: ['admin'],
        }, {
          name: "影像管理",menuId:"ce34c5be5d5249b19c248b58ef9c6752", icon:  "el-icon-help", path: "/mainPage/scanPreResult", allows: ['admin'],
          children: [{
            name: "影像查询",menuId:"ce34c5be5d5249b19c248b58ef9c6752", icon:  "el-icon-help", path: "/mainPage/scanPreResult", allows: ['admin'],
          },
          {
            name: "华高扫描专用",menuId:"hg-scan-001", icon:  "el-icon-printer", path: "/cef/hgScan", allows: ['teacher'], target: "_blank"
          }
        ]
        },{
          name: "测试页",menuId:"ce34c5be5d5249b19c248b58ef9c6752", icon:  "el-icon-help", path: "/mainPage/scantronManagement", allows: ['admin'],
        }, {
          name: "历史成绩",menuId:"d9f9f17934654a7dbb7b9b1e4f6ba5fb", icon:  "el-icon-help", path: "/mainPage/historyScore", allows: ['admin'],
        }, {
            name: "数据统计",menuId:"f70b387833fb429eb2bdd38f278fd47a", icon:  "vknowfont vicon-tongji", path: "/mainPage/dataDashBoard", allows: ['admin'],
        // 单位管理员
        }, {
            name: "用户管理",menuId:"84c40bffe77b4f16b42e6dcd929f7f48", icon:  "vknowfont vicon-yonghu", path: "/mainPage/schoolList", allows: ['sclAdmin'],
            children: [{
                name: "学生信息",menuId:"f19b7f4a6de84ede848737e4a9dc41c9", icon:  "el-icon-help", path: "/mainPage/scl/studentList", allows: ['sclAdmin'],
            }, {
                name: "教师信息",menuId:"eee82a4d6f55423cbd2f7539e81123d3", icon:  "el-icon-s-order", path: "/mainPage/scl/teacherList", allows: ['sclAdmin'],
            }, {
                name: "行政班信息",menuId:"77c1552f3fbd486c9777b65a938d855f", icon:  "el-icon-upload", path: "/mainPage/scl/hardClassList", allows: ['sclAdmin'],
            }, {
                name: "课程信息",menuId:"68af046d4300425fb7147ae0256e4964", icon:  "el-icon-s-tools", path: "/mainPage/scl/courceList", allows: ['sclAdmin'],
            }, {
                name: "教学班信息",menuId:"301fc5e517c5427bb5665e4979939063", icon:  "el-icon-help", path: "/mainPage/scl/teachingClassList", allows: ['sclAdmin'],
            }, {
                name: "综合上传",menuId:"aaed33bb16304cecb5dae61716eda6f5", icon:  "el-icon-upload2", path: "/mainPage/allUpload", allows: ['sclAdmin'],
            }]
        }, {
            name: "数据统计",menuId:"680ee567a57d446fa21e68fc1bd5ca45", icon:  "vknowfont vicon-tongji", path: "/mainPage/dataDashBoard2", allows: ['sclAdmin'],
            // 教师
        }, {
            name: "基础信息",menuId:"5b9469ec695f4991bb3fbb68dc8d9926", icon:  "vknowfont vicon-svg-", path: "/mainPage/schoolList", allows: ['teacher'],
            children: [{
                name: "课程信息",menuId:"", icon:  "el-icon-s-tools", path: "/mainPage/tch/courceList", allows: ['teacher'],
            }, {
                name: "我的教学班",menuId:"", icon:  "el-icon-help", path: "/mainPage/tch/teachingClassList", allows: ['teacher'],
            }, {
                name: "我的行政班",menuId:"", icon:  "el-icon-upload", path: "/mainPage/tch/myClassList", allows: ['teacher'],
            }, 
            // {
            //     name: "我的学生",menuId:"", icon:  "el-icon-s-custom", path: "/mainPage/tch/myStudentList", allows: ['teacher'],
            // }
        ]
        }, {
            name: "笔试考试",menuId:"", icon:  "vknowfont vicon-gangbi", path: "/mainPage/exam/newExam", allows: ['teacher', 'sclAdmin', 'admin'],
        },
        {
            name: "我的批阅",menuId:"", icon:  "el-icon-s-management", path: "/mainPage/myReviewTask", allows: ['teacher', 'sclAdmin', 'admin'],
        },
        // 新版答题卡
        {
            name: "答题卡",menuId:"", icon:  "vknowfont vicon-datiqia", url: "/scantron-vue/#/list/index", allows: ['teacher'],
        },
        {
            name: "答题卡(旧)",menuId:"", icon:  "vknowfont vicon-datiqia", url: "/anwcard/#/list/index", allows: ['teacher'],
        }, 
        {
        name: "扫描",menuId:"0048b8e5429c4b4985a79d5064404157", icon:  "vknowfont vicon-saomiaoyi", path: "/mainPage/schoolList", allows: ['teacher'],
        children: [{
            name: "扫描答题卡",menuId:"0d4350b10cd3439489c61fd2e9a59511", icon:  "el-icon-help", path: "/mainPage/cef/scan", allows: ['teacher'],
        },{
            name: "华高扫描专用",menuId:"hg-scan-001", icon:  "el-icon-printer", path: "/cef/hgScan", allows: ['teacher'], target: "_blank"
        },
              // {
              //   name: "异常",menuId:"", icon:  "el-icon-help", path: "/scanPre?a=211",  target: "new", allows: ['teacher'],
              // },
            //   {
            //     name: "试卷预处理",menuId:"8fbc8ee418ae480fbc189065b0187d00", icon:  "el-icon-help", path: "/scanPre", target: "new", allows: ['teacher'],
            // }, 
            {
                name: "影像查询",menuId:"da362b08dd974e8e83cb9235a8707ede", icon:  "el-icon-help", path: "/mainPage/scanPreResult", allows: ['teacher'],
            }, 
            {
                name: "测试页",menuId:"c7ef0d0aa0e64c7b877d60306f740c6a", icon:  "el-icon-help", path: "/mainPage/scantronManagement", allows: ['teacher'],
            }
            //     name: "已识别试卷(旧)",menuId:"", icon:  "el-icon-help", path: "/mainPage/scanPreResultOld", allows: ['teacher'],

            // }, {
            //     name: "缺考学生",menuId:"", icon:  "el-icon-help", path: "/mainPage/missingExamsList", allows: ['teacher'],
            // }
        ]

        }, {
            name: "我的成绩",menuId:"1748a440086e42eb8876f5d34f124b7f", icon:  "vknowfont vicon-chengjichaxun-", path: "/mainPage/myScoreList", allows: ['student'],

        }, {
            name: "成绩管理",menuId:"32c0ced66e17437ab0c472225814abaa", icon:  "vknowfont vicon-chengjichaxun-", path: "/mainPage/schoolList", allows: ['teacher','sclAdmin','admin'],
            children: [
            //     {
            //     name: "在线查询成绩",menuId:"34ed07e03c284ecfa6fcaefc5efd6b2f", icon:  "el-icon-help", path: "/mainPage/examsList", allows: ['teacher','sclAdmin'],
            // }, 
            {
                name: "试卷分析",menuId:"cd72cfa7e568496eaefdeb3150dd1165", icon:  "el-icon-help", path: "/mainPage/examsAnalyse", allows: ['teacher','sclAdmin'],
            }, {
                name: "归档下载",menuId:"281ab21836e447aa951810e476ee7705", icon:  "el-icon-help", path: "/mainPage/downloadList", allows: ['teacher','sclAdmin'],
            // }, {
            //     name: "总评表",menuId:"", icon:  "el-icon-help", path: "/mainPage/report/overallReport", allows: ['teacher'],
            // }, {
            //     name: "达成度",menuId:"", icon:  "el-icon-help", path: "/mainPage/degree/degreeList", allows: ['teacher'],
            },
           
           ]
        // },{
        //   name: "数据分析",menuId:"", icon:  "vknowfont vicon-mubiaoyudacheng", url: "https://www.51obe.com/analyse/#/login?t=normal", allows: ['teacher', 'sclAdmin', 'admin'],
        // }, {
        //     name: "达成度",menuId:"", icon:  "vknowfont vicon-mubiaoyudacheng", path: "/mainPage/degree/degreeList", allows: ['teacher'], hosts: ['www.51obe.com'],
        },
        {
            name: "测试页面", icon:  "vknowfont vicon-chengjichaxun-", path: "/teacher/teacherEvaluation1", allows: ['teacher'],
            children: [
            {
                name: "评教页面", icon:  "vknowfont vicon-chengjichaxun-", path: "/teacher/teacherEvaluation", allows: ['teacher'],target: "_blank"
            }
            ]
        }
        //   {
        //     name: "软件下载",menuId:"", icon:  "vknowfont vicon-ceshi", path: "/mainPage/softList", allows: ['teacher'],
        // // }, {
        // //     name: "总评表管理",menuId:"", icon:  "el-icon-user", allows: ['teacher'],
        // //     children: []
        // }
        ],
        userData: [],
    };
  },
    // watch: {
    //     $route:  {
    //         immediate: true,
    //         handler(newVal, oldval){
    //             console.log('route watch', newVal, oldval);
    //         },
    //         // 深度监听
    //         deep: true
    //     }
    // },
  computed:{
      ...mapGetters('user', [
          'permission_routers',
          'isCollapse',
          'sidebar',
          'menuIndex'
      ]),
      ...mapState({
          userInfo: state => state.user.userInfo,
          scanExamInfo: state=>state.scanExam.scanExamInfo,
      }),
  },
  created(){
  },
  mounted(){
      if(typeof scanManager == 'undefined') {
          this.isInCefClient = false;
      }else{
          this.isInCefClient = true;
      }
      this.loadUserMenu();
  },
  methods: {
      isInHost(h){
          let host = window.location.host;
          // console.log('host', host);
          return h == host;
      },
      // 过滤左侧菜单栏
      loadUserMenu(){
          console.log('host', window.location.host);
          let role = this.userInfo.role;
          this.userData = [];
          let that = this;
          for (let i=0; i<this.data.length; i++){
            // debugger
              let d = this.data[i];
              if(this.isInCefClient){
                  if(d.name === "扫描"){
                      for (let j=d.children.length-1; j>=0; j--){
                          let child = d.children[j];
                          //if(child.path && (child.path !== "/mainPage/cef/scan" &&  child.path !== "/scanPre?a=211")){
                        if(child.path && child.path !== "/mainPage/cef/scan" ){
                              d.children.splice(j,1);
                          }
                      }
                      this.userData.push(d);
                  }
              }else{
                //查询当前用户的初始化额外的菜单
                // this.extraMenuInit();

                  let allows = d.allows;
                  let hosts = d.hosts;
                  if(hosts && hosts.length > 0){
                      let ht = XEUtils.find(hosts, item => that.isInHost(item));
                      if(!ht) continue;
                  }
                  let ar = XEUtils.find(allows, item => {
                      return item == role;
                  });
                  if(ar){
                      if(d.children && d.children.length > 0){
                          for (let j=d.children.length-1; j>=0; j--){
                              let child = d.children[j];
                            // if(child.path && (child.path === "/mainPage/cef/scan" || child.path === "/scanPre?a=211")){
                            if(child.path && child.path === "/mainPage/cef/scan" ){
                                  console.log("path", d.path);
                                  if(!this.isInCefClient){
                                      d.children.splice(j,1);
                                  }
                              }
                            //   if(child.path && child.path === "/mainPage/scantronManagement" ){
    
                            //     let schoolType = this.userInfo.schoolType
                            //     if(schoolType !== '本科' && schoolType!== undefined && schoolType!== '' && schoolType!== null ){
                            //         d.children.splice(j,1);
                            //     } 
                            //   }
                          }
                      }
                      if(d.name == '新答题卡'){
                        // if(this.userInfo.licenceKey == 'fzsk'){
                            this.userData.push(d);
                        // }
                      }
                    //   else if(d.name =='成绩管理'){
                    //     // 是成绩管理时 教师用户开放 二级管理员和管理员仅开放给工业学校
                    //     if(this.userInfo.role == "teacher"){
                    //         this.userData.push(d);
                    //     }else{
                    //         if(this.userInfo.licenceKey == 'fjgx'){
                    //             this.userData.push(d);
                    //         }
                    //     }
                    //   }
                      else{
                        this.userData.push(d);
                      }
                      
                  }

                  //添加个性化菜单功能
                  // var menuSign = "EXTRA_MENU"
                  // let menuFlag = XEUtils.find(allows, item => {
                  //   return item == menuSign;
                  // });
                  // //如果存在，则把个性化的菜单添加
                  // if(menuFlag){
                  //   if (allExtMenu.includes(d.menuId)) {
                  //     if(!this.userData.includes(d)){
                  //       this.userData.push(d);
                  //     }
                  //   }
                  // }
              }
          }
      },
    extraMenuInit(){
      let that = this;
      this.loading = true
      let param = { controllerName: 'public/', methodName: 'getExtMenuAuth', param: { adminId: this.userInfo.id}};
      simpleApi.post(param).then(({ result: { code, data}, sysCode}) => {
        that.loading = false
        if(code != 0){
          this.allExtMenu = data.list;
        }
      }).catch((error) => {
        that.loading = false;
        console.log("error")
      });
    },
  }
};
</script>


<style lang="scss" type="text/scss" rel="stylesheet/scss">
  $left-bgColor:#fff;  // 左侧菜单背景颜色;
  $icon-link:#FF6C60;
    .menu_left{
        position: absolute;
        top:0;
        left:0;
        bottom:0;
    }
    .menu_page_top{
        width:100%;
        height: 60px;
        align-items: center;
        // justify-content: space-around;
        text-transform: uppercase;
        box-sizing: border-box;
        box-shadow:0px 2px 5px 0px rgba(230,224,224,0.5);
        .logo {
            height: 36px;
            width: 36px;
            vertical-align: middle;
            display: inline-block;
            border-radius: 10px;
        }
        .closeLogo{
            width:30px;
            height:30px;
        }
        .title{
            font-size: 22px;
            background-color: transparent;
            border: none;
            // color: black;
            i{
                // color:#02b6fd;
            }
        }
    }
  .menu_page_bottom {
      width:100%;
      overflow-y: scroll;
      overflow-x: hidden;
      flex:1;
      // margin-top:3px;
      z-index: 10;
      box-shadow: 0 0 10px 0 rgba(230, 224, 224, 0.5);
      .vknowfont {
          margin-right: 8px;
      }
  }
</style>
